import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthProvider';

/* 
    use to set authentication token
*/
const useAuth = () => {
    return useContext(AuthContext);
};

export default useAuth;